import { IconChevronDown } from '@tabler/icons-react'
import { ReactNode, useState } from 'react'

import { DeepinsightSymbolAnimated } from '../../icons'
import { getInitials } from '../ActivityLog'
import { AstraAvatar } from '../AstraAvatar/AstraAvatar'
import { AstraPopover } from '../AstraPopover/AstraPopover'
import { AstraTooltip } from '../AstraTooltip/AstraTooltip'
import { AnimatedController } from '../SpecialEffects/AnimationHelpers'
import { AstraParagraph } from '../Typography/AstraParagraph/AstraParagraph'
import { astraTwMerge } from '../Utilities/astraTwMerge'
import { useSidenavContext } from './AstraSideNavContext'
import { UserMenuItem } from './AstraSideNavUserMenuItem'
import { UserMenuContext } from './AstraUserMenuContext'

export const UserMenuDivider = () => <div className="col-span-full h-px w-full bg-surface-backdrop" />

type Props = {
    username: string
    children: ReactNode
}

export const UserMenu = ({ children, username }: Props) => {
    const isOpen = useSidenavContext()
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)

    return (
        <AstraTooltip tooltipContent={username} side="right" hidden={isOpen}>
            <AstraPopover
                isOpen={isUserMenuOpen}
                onOpenChange={setIsUserMenuOpen}
                noPadding
                side="right"
                align="start"
                popoverContent={
                    <div
                        data-test="user-menu"
                        className="bg-surface-default grid w-52 grid-cols-[28px_1fr] grid-rows-1 flex-col items-center gap-y-2 rounded-lg px-3 py-2 shadow-lg"
                    >
                        <UserMenuContext value={{ closeMenu: () => setIsUserMenuOpen(false) }}>
                            <UserMenuItem>
                                <AnimatedController>
                                    <DeepinsightSymbolAnimated width={24} height={24} />
                                </AnimatedController>
                                <AstraParagraph variant="body-large" className="whitespace-nowrap text-start">
                                    Deepinsight Hero
                                </AstraParagraph>
                            </UserMenuItem>

                            <UserMenuItem>
                                <AstraAvatar variant="initial" initials={getInitials(username)} size="small" useColorGenerator />
                                <AstraParagraph className="truncate whitespace-nowrap" variant="body-small">
                                    {username}
                                </AstraParagraph>
                            </UserMenuItem>

                            {children}
                        </UserMenuContext>
                    </div>
                }
            >
                <button
                    data-test="user-menu-button"
                    className={astraTwMerge(
                        'flex h-8 cursor-pointer items-center rounded-lg transition hover:bg-surface-backdrop',
                        isOpen ? 'w-min gap-1 px-2 py-2' : 'mx-auto w-8 justify-center',
                        isUserMenuOpen ? 'bg-surface-backdrop' : 'bg-transparent'
                    )}
                >
                    <AnimatedController>
                        <DeepinsightSymbolAnimated width={24} height={24} />
                    </AnimatedController>

                    {isOpen && (
                        <>
                            <AstraParagraph weight="medium" className="whitespace-nowrap text-muted">
                                Deepinsight Hero
                            </AstraParagraph>

                            <IconChevronDown size={14} stroke={1.8} />
                        </>
                    )}
                </button>
            </AstraPopover>
        </AstraTooltip>
    )
}
